import HeaderDashboard from '../../Components/HeaderDashboard'
import Styled from './settings.module.css'
import { FiSave, FiX } from 'react-icons/fi'
import ProviderImagesOrButtonForUpload from '../../Components/ProviderImagesOrButtonForUpload'
import { useEffect } from 'react'
import ProviderViewTextAndTextarea from '../../Components/ProviderViewTextAndTextarea'
import ToolBar from '../../Components/ToolBar'
import Footer from '../../Components/Footer'
import { FormGroup, InputText, LabelText, Button } from '../../Components/Global'
import Loading from '../../Components/Loading'
import { useLandingContext } from '../../Context'

function Settings() {

    const useLanding = useLandingContext()

    useEffect(() => {
        useLanding.handleGetWebsiteSettings()
        // eslint-disable-next-line
    }, [])

    return (
        <section className={Styled.container}>
            {useLanding.loading && <Loading />}
            <HeaderDashboard page="settings" />
            <section className={Styled.container_settings}>
                <form className={Styled.services_settings}>
                    <div className={Styled.form_group}>
                        <div className={Styled.content_upload}>
                            <ProviderImagesOrButtonForUpload value={useLanding.websiteSettings.logo} />
                        </div>
                        <div className={Styled.content_upload}>
                            <ProviderImagesOrButtonForUpload value={useLanding.websiteSettings.background} />
                        </div>
                        <div className={Styled.content_upload}>
                            <ProviderImagesOrButtonForUpload value={useLanding.websiteSettings.imgCurriculo} />
                        </div>
                        <hr />
                    </div>
                    <FormGroup className={Styled.form_group}>
                        <LabelText htmlFor="atendimentos">Atendimentos:</LabelText>
                        <InputText maxLength={600} placeholder="Digite algo sobre seus atendimentos" type="text" id="atendimentos" value={useLanding.websiteSettings.attendance} onChange={e => useLanding.setWebsiteSettings({
                            ...useLanding.websiteSettings, attendance: e.target.value
                        })} />
                    </FormGroup>
                    <FormGroup className={Styled.form_group}>
                        <LabelText htmlFor="livros">Livros:</LabelText>
                        <InputText maxLength={600} placeholder="Digite algo sobre seus livros" type="text" id="livros" value={useLanding.websiteSettings.books} onChange={e => useLanding.setWebsiteSettings({
                            ...useLanding.websiteSettings, books: e.target.value
                        })} />
                    </FormGroup>
                    <FormGroup className={Styled.form_group}>
                        <LabelText htmlFor="palestras">Palestras:</LabelText>
                        <InputText maxLength={600} placeholder="Digite algo sobre suas palestras" type="text" id="palestras" value={useLanding.websiteSettings.speeches} onChange={e => useLanding.setWebsiteSettings({
                            ...useLanding.websiteSettings, speeches: e.target.value
                        })} />
                    </FormGroup>
                    <FormGroup className={Styled.form_group}>
                        <LabelText htmlFor="cursos">Cursos:</LabelText>
                        <InputText maxLength={600} placeholder="Digite algo sobre seus cursos" type="text" id="cursos" value={useLanding.websiteSettings.courses} onChange={e => useLanding.setWebsiteSettings({
                            ...useLanding.websiteSettings, courses: e.target.value
                        })} />
                    </FormGroup>
                </form>
                <form className={Styled.home_settings}>
                    <FormGroup className={Styled.form_group}>
                        <LabelText htmlFor="blog">Blog:</LabelText>
                        <InputText maxLength={300} type="text" id="blog" placeholder="Digite a url do blog" value={useLanding.websiteSettings.blog} onChange={e => useLanding.setWebsiteSettings({
                            ...useLanding.websiteSettings, blog: e.target.value
                        })} />
                    </FormGroup>
                    <FormGroup className={Styled.form_group}>
                        <LabelText htmlFor="whatsapp">Whatsapp:</LabelText>
                        <InputText maxLength={100} type="text" id="whatsapp" placeholder="(55) 3399965874" value={useLanding.websiteSettings.whatsapp} onChange={e => useLanding.setWebsiteSettings({
                            ...useLanding.websiteSettings, whatsapp: e.target.value
                        })} />
                    </FormGroup>
                    <FormGroup className={Styled.form_group}>
                        <ProviderViewTextAndTextarea title="Titulo:" valueState={useLanding.websiteSettings.prominentTitle} />
                        <ToolBar valueState={useLanding.websiteSettings.prominentTitle} />
                    </FormGroup>
                </form>
                <div className={Styled.curriculo_settings}>
                    <hr />
                    <ProviderViewTextAndTextarea title="Sobre:" valueState={useLanding.websiteSettings.textCurriculo} />
                    <div className={Styled.container_buttons_action}>
                        <ToolBar valueState={useLanding.websiteSettings.textCurriculo} />
                        <Button className={Styled.btn_clear} width={35} height={3} onClick={useLanding.handleClearInputs}>
                            <FiX />
                            Limpar
                        </Button>
                        <Button type="button" className={Styled.btn_save} width={35} height={3} onClick={useLanding.handleSaveSettingsWebsite}>
                            <FiSave />
                            Salvar
                        </Button>
                    </div>
                </div>
            </section>
            <Footer />
        </section>
    )
}

export default Settings